import styled from 'styled-components';
import ActivitiesIconSvg from '../../assets/hotels/amenities/activities.svg';

const ActivitiesIcon = styled(ActivitiesIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ActivitiesIcon;
